import { Container, Row, Col, Button } from 'react-bootstrap';
import projectsBackgroundImage from '../assets/images/backgrounds/projects.jpg';

const ProjectsBackground = () => {
  return (
    <div className="page-header min-vh-80" style={{backgroundImage: `url(${projectsBackgroundImage})`}} loading="lazy">
      <span className="mask bg-gradient-dark opacity-8"></span>
      <Container>
        <Row>
          <Col lg={12} className="d-flex justify-content-start flex-column">
            <h1 className="text-white text-start mb-4">My Projects</h1>
            <h3 className="text-white text-start fw-light mb-0 ms-1">Built projects with various technologies, most of them solo.</h3>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectsBackground;
